import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { Filter4HistoryStatus, HistoryStatusList, HistoryStatusModel } from '../models/HistoryStatusModel';
import { AppsettingsConfig } from 'src/app/modules/client-config/models/client-config';
import { strangerInfo } from '../models/strangerProfile';
import { IUpdatePersonalContacts } from '../models/RegisterStrangerRequest';
import { IResponse } from '../models/IResponse';
import StrangerAccessPermissions from '../models/stranger-permissions';
import { OrganizationCheckResponse } from '../models/organization-check-response';
import IEsiaResponse from 'src/app/modules/auth/models/interfaces/IEsiaResponse';
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  backendUrl;

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private appsettings: AppsettingsConfig
  ) {
    this.backendUrl = this.appsettings.backendUrl;
  }

  getHistoryStatus(filter: Filter4HistoryStatus): Observable<HistoryStatusModel> {
    return this.http.get<HistoryStatusModel>(`${this.backendUrl}/account/status/list?count=${filter.count}&offset=${filter.offset}`);
  }

  public getStranger(): Observable<strangerInfo> {
    return this.http.get<strangerInfo>(`${this.backendUrl}/stranger/get-stranger`);
  }

  /** Изменение персональных контактных данных иностранца (почта, телефон, код страны телефона) */
  public updatePersonalContacts(data: IUpdatePersonalContacts): Observable<IResponse> {
    return this.http.post<IResponse>(`${this.backendUrl}/stranger/update-personal-contacts`, data);
  }

  getStrangerHistoryStatus(filter: Filter4HistoryStatus): Observable<HistoryStatusList[]> {
    return this.http.get<HistoryStatusList[]>(`${this.backendUrl}/stranger/strangerHistoryStatus?count=${filter.count}&offset=${filter.offset}`);
  }

  /** Доступы и роли иностранца */
  public getStrangerPermissions(): Observable<StrangerAccessPermissions> {
    return this.http.get<StrangerAccessPermissions>(`${this.backendUrl}/stranger/permissions`);
  }

  checkStrangerOrganization(inn: string, countryId: string, clientId: number): Observable<OrganizationCheckResponse> {
    return this.http.get<OrganizationCheckResponse>(`${this.backendUrl}/stranger/organization/check?inn=${ inn }&countryId=${ countryId }&clientId=${ clientId }`);
  }

  changeStrangerRole(organizationId: string): Observable<IEsiaResponse> {
    return this.http.post<IEsiaResponse>(`${this.backendUrl}/OAuth/stranger-change-role`, { id: organizationId });
  }
}
